import { useEffect, useRef, useState } from "react"

import { Code2Icon } from "lucide-react"

import { define, prop } from "../utils"
import Placeholder from "../utils/Placeholder"

import BasePreview from "./base"

function HTMLPreview({ properties: { content, ...properties }, ...props }) {
  const ref = useRef(null)
  const [document, setDocument] = useState(null)
  const [height, setHeight] = useState(null)

  useEffect(() => {
    if (document?.body) {
      const height = document.body.scrollHeight
      setHeight(height)
    }
  }, [document])

  return <BasePreview properties={properties} {...props}>
    <div>
      {!height ? <Placeholder content="Preview not available for this HTML" size="h-15" /> : null}
      <iframe
        ref={ref}
        sandbox="allow-same-origin"
        className="pointer-events-none"
        style={{ overflow: "hidden", width: "100%", height: `${height}px` }}
        onLoad={() => setDocument(ref.current?.contentDocument)}
        srcDoc={`
          <!DOCTYPE html>
          <html>
            <head>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/tailwindcss@4.1.6/preflight.css">
            </head>
            <body>${content}</body>
          </html>
        `}
      ></iframe>
    </div>
  </BasePreview>
}

function HTML({ content, attributes }) {
  return <div dangerouslySetInnerHTML={{ __html: content }} {...attributes} />
}

export default define('html', HTMLPreview, HTML)
  .palete(<Code2Icon size={20} />, 'HTML', 'Advanced')
  .property(prop.predefined.customClass())
  .property(prop.code('Content', 'content').category('default').own())
  .property(prop.predefined.attributes())
  .defaultProps({
    content: '<!-- Insert your HTML code here -->',
  })
  .build()
